<template>
    <img :src="src" class="thumbnail"/>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {getUrlParameter} from "../../lib/utils";

    export default {
        name: "Thumbnail",

        computed:{
            ...mapGetters([
                'project',
                'played',
                'videos',
                'nodes'
            ]),
            src(){
                if( window.location.href.includes("startNodeId")) {
                    const node  = this.nodes[ getUrlParameter('startNodeId') ];
                    const video = this.videos[node.media_id];
                    return (video) ? video.thumbnail_url : this.project.image_url;
                }
                return this.project.image_url;
            }
        },

        watch:{
            played(newVal){
                if(newVal){
                    const targets = this.$el;
                    this
                        .$anime
                        .timeline()
                        .add({
                            targets,
                            scale: 2,
                            duration: 1000,
                            opacity:0,
                            zIndex: '-1',
                            easing: 'easeOutExpo',
                        })
                }
            }
        }
    }
</script>

<style scoped>
    .thumbnail {
        width: 100%;
        height: auto;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 4200;
    }
</style>